import { render, staticRenderFns } from "./challengeList.vue?vue&type=template&id=7350f5a5&"
import script from "./challengeList.vue?vue&type=script&lang=ts&"
export * from "./challengeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports